import { Get, Post } from '@/utils/axios'

/**
 * 获取枚举
 * @param {参数} param
 */
export function getEnum(param) {
  return Get('/common/GetEnum', param)
}

/**
 * 获取枚举集合
 * @param {参数} param
 */
export function getEnums(param) {
  return Get('/common/GetEnums', param)
}

/**
 * 获取字典
 * @param {参数} param
 */
export function getDict(param) {
  return Get('/common/GetDict', param)
}

/**
 * 获取字典集合
 * @param {参数} param
 */
export function getDicts(param) {
  return Get('/common/GetDicts', param)
}

/**
 GET
/app/Common/GetStores
获取店铺信息
 */
export function getStores(param) {
  return Get('/common/GetStores', param)
}
export function getCommon(param) {
  return Get('/common', param)
}

/**
 GET
/app/Common/GetCustomerInfo
获取客户信息
 */
export function getCustomerInfo(param) {
  return Get('/common/GetCustomerInfo', param)
}

/* 获取配置 */
export function getConfig() {
  return Get('/Common/GetConfig')
}
export function UploadFile(data) {
	return Post('/Common/UploadFile', data)
}
export function GetBanner() {
  return Get('/Common/GetBanner')
}
export function GetTransportTraceRule() {
  return Get('/Common/GetTransportTraceRule')
}
export function TrialTransportTrace(data) {
	return Post('/Common/TrialTransportTrace', data)
}
export function getTextConfig(data) {
	// return 1
	// return {
	// 	text1: 'Yiwu Chenrong Trading., Co.,Ltd',
	// 	text2: 'China, Zhejiang Province, Jinhua City, Yiwu, QuCheng Street NO.18, building NO.7, 4th Floor'
	// }
	return new Promise((resolve) => {
		resolve({
			text1: 'Yiwu Chenrong Trading Co., Ltd.',
			text2: 'China, Zhejiang Province, Jinhua City, Yiwu, QuCheng Street NO.18, building NO.7, 5th Floor'
		})
	})
}
// 获取shopify店铺信息
export function GetStoresByType(type) {
  return Get('/Common/GetStoresByType/' + type)
}
export function AsyncWholesaleOrder(data) {
	return Post('/Order/AsyncWholesaleOrder', data)
}
export function ShopifyReconnect(data) {
	return Post('/Shopify/Reconnect', data)
}
// 获取充值币别单个
export function GetRechargeRateById(data) {
  return Post('/Common/GetRechargeRateById', data)
}
// 获取充值币别
export function GetRechargeCurrency(data) {
	return Post('/Common/GetRechargeCurrency', data)
}
// 获取客户端海外仓账单类型枚举字典(仓租费 / 后续扩展)
export function GetGlobalBillType() {
	return Get('/Common/GetGlobalBillType')
}
// 获取海外仓列表
export function GetOverseasWarehouses() {
  return Get('/Warehouse/GetOverseasWarehouses')
}
// 获取全部仓库（含国内仓+海外仓，排除"其他"）
export function GetAllWarehouses() {
  return Get('/Warehouse/GetAllWarehouses')
}